import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '@/auth/use-auth';
import UiButton from '@/ui/UiButton/UiButton';
import UiLoader from '@/ui/UiLoader/UiLoader';
import ClientConfig from '@/components/ClientConfig/ClientConfig';
import UiIcon from '@/ui/UiIcon/UiIcon';

export default function Home() {
  const navigate = useNavigate();
  const { access_token, isLoading, score, userInfo, token } = useAuth();
  const [isConfigActive, setIsConfigActive] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (access_token || token) {
      navigate('/');
    }
  }, [access_token, token]);

  if (isLoading) {
    return <UiLoader />;
  }

  if (access_token || token) {
    return (
      <div className="page">
        <div className="page-title">
          Вы успешно авторизовались!
        </div>
        <div className="page-text">
          Токен доступа:
        </div>
        <div className="page-token" data-testid="token">
          {access_token || token}
        </div>
        <br />
        {
          score ? (
            <>
              <div className="page-text">
                Скоринг пользователя:
              </div>
              <div className="page-token" data-testid="score">
                {score}
              </div>
            </>
          ) : null
        }
        <br />
        {
          userInfo ? (
            <>
              <div className="page-text">
                Информация о пользователе:
              </div>
              <div className="page-token" data-testid="info">
                {userInfo}
              </div>
            </>
          ) : null
        }
      </div>
    );
  }

  return (
    <div className="page">
      <div className='header-logo'>
        <UiIcon name="logo" />
      </div>
      {isConfigActive ? <ClientConfig setIsConfigActive={(isActiv) => setIsConfigActive(isActiv)} /> : <div>
        <div className='page-content-wrapper'>
          <div className="page-title">
            Добро пожаловать
          </div>
          <div className="page-text">
            Это тестовое приложение для демонстрации работы сервиса авторизации SDK Public.
          </div>
        </div>
        <div className='page-content-wrapper'>
          <div className='init-buttons-wrap'>
            <UiButton
              className='index-element-1'
              dataTestId="enter"
              onClick={() => navigate('/login')}
            >
              Войти
            </UiButton>
            <UiButton
              className='index-element-2'
              type='secondary'
              dataTestId="parameters"
              onClick={() => setIsConfigActive(true)}
            >
              Настроить параметры
            </UiButton>
          </div>
          <UiButton
            className='index-element-3'
            type='secondary'
            dataTestId="gpid-buttons"
            onClick={() => navigate('/buttons')}
          >
            Кнопки Газпром ID
          </UiButton>
        </div>
      </div>}
    </div>
  );
}
